import { get, isAuthenticatedUser } from 'js/lib/user';

import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';

/**
 * Determines if WES Ask Coursera should be displayed based on the current pathname.
 * Used across WES applications (teams-v2, ent-website, enterprise-admin-account).
 *
 * @param pathname - Current URL pathname from router
 * @returns boolean - true if coach should be shown
 */

export const shouldShowWESAskCoursera = (pathname: string): boolean => {
  const userId = isAuthenticatedUser() ? get()?.id?.toString() : undefined;
  const coachEnabled = EnterpriseExperiments.get('enableWESCoach');
  const coachEnabledPaths = ['/purchase/account', '/purchase/billing', '/business/teams'];

  return Boolean(userId && coachEnabled && coachEnabledPaths.some((path) => pathname.includes(path)));
};
